import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Avatar, Typography, Icon } from 'foundations-library/components'

const useStyles = makeStyles((theme) => {
    const { colors } = theme['foundations-library']

    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch'
        },
        transcription: {
            display: 'flex',
            padding: '20px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '20px',
            alignSelf: 'stretch'
        },
        chatItem: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            alignSelf: 'stretch'
        },
        info: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
            flex: '1 0 0'
        },
        nameAndTimeContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            alignSelf: 'stretch'
        },
        ellipse: {
            width: '4px',
            height: '4px',
            borderRadius: '50%',
            backgroundColor: colors.neutral[400]
        }
    }
})

/**
 *
 */
export const formatTime = (startTimeInSec: number, afterStartTimeInMilliSec: number) => {
    const myTime = new Date((startTimeInSec * 1000) + afterStartTimeInMilliSec)
    let hours = myTime.getHours()
    const minutes = myTime.getMinutes().toString().padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours || 12
    return `${hours}:${minutes} ${ampm}`.replace('  ', ' ')
}

interface SpeakerInterface {
    display_name: string
    e164: string
    voip_phone_id: number | null
}

interface LineInterface {
    speaker_id: string
    text: string
    ts_start_ms: number
}

interface TranscriptionInterface {
    full_transcription: string
    voip_phone_id: number
    speakers: {
        [key: string]: SpeakerInterface
    },
    lines: {
        [key: number]: LineInterface
    }
}

/**
 *
 */
export default function CallTranscript ({ transcription, time, getContactName, doesOtherContactExist, isOtherContact }: { transcription?: TranscriptionInterface, time: number, getContactName: (number: string) => string, doesOtherContactExist: boolean, isOtherContact: (number: string) => boolean }): JSX.Element {
    const classes = useStyles()

    const renderAvatar = (speaker: SpeakerInterface) => {
        const { e164 } = speaker

        if (isOtherContact(e164) && !doesOtherContactExist) {
            return (
                <Icon
                    color='neutral-700'
                    name='contacts'
                    size={38}
                    data-testid='contacts-icon'
                />
            )
        }

        let getDisplayNameForAvatar = getContactName(e164)
        if (!haveAlpha(getDisplayNameForAvatar)) getDisplayNameForAvatar = getDisplayNameForAvatar.replace(/\D/g, '')

        return (
            <Avatar initials={getDisplayNameForAvatar} size='small' />
        )
    }

    const haveAlpha = (displayName: string) => /[a-zA-Z]+/.test(displayName)

    return (
        <div className={classes.root}>
            <div className={classes.transcription}>
                {
                    Object.entries(transcription?.lines || {})?.map(([lineKey, line]) => {
                        const speaker = transcription?.speakers[line.speaker_id]
                        if (!speaker) return null

                        return (
                            <div className={classes.chatItem} key={lineKey}>
                                {renderAvatar(speaker)}
                                <div className={classes.info}>
                                    <div className={classes.nameAndTimeContainer}>
                                        <Typography variant='subtitle1' color='neutral-900'>{getContactName(speaker.e164)}</Typography>
                                        <div className={classes.ellipse} />
                                        <Typography variant='body1' color='neutral-700'>{formatTime(time, line.ts_start_ms)}</Typography>
                                    </div>
                                    <Typography variant='body2' color='neutral-900'>
                                        {line.text}
                                    </Typography>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
